import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/customColorPickerStyle';
import Done from '@material-ui/icons/Done';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IColorPickerProps {
	colors: string[];
	selectedColor: string;
	onChange: Function;
}

const CustomColorPicker = ({ colors, selectedColor, onChange }: IColorPickerProps) => {
	const classes = useStyles();
	return (
		<div className={classes.container} id="colors-container">
			{colors.map((color, index) => (
				<div
					key={index}
					className={classNames({
						[classes.tileWrapper]: true,
						[classes.active]: selectedColor === color,
					})}
				>
					<div className={classes.tile} style={{ backgroundColor: color }} onClick={() => onChange(color)} />
					{selectedColor === color && <Done className={classes.icon} />}
				</div>
			))}
		</div>
	);
};

export default CustomColorPicker;
